export default "__VITE_ASSET__yErodatI__"